import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageRequest } from 'src/app/shared/model/page/page-request';
import { PageResult } from 'src/app/shared/model/page/page-result';
import { Courier } from 'src/app/shared/model/courier';
import { HttpUtils } from 'src/app/shared/services/common/http-utils';
import { BaseFilter } from 'src/app/shared/model/filter/base-filter';
import { Street } from 'src/app/shared/model/street';

@Injectable({
  providedIn: 'root',
})
export class StreetService {

  constructor(private readonly http: HttpClient) { }

  findStreets(localityId: string, keyword: string, pageRequest: PageRequest): Observable<PageResult<Street>> {
    const queryParams = {
      keyword: keyword
    };
    const httpParams = HttpUtils.createHttpParams(queryParams, pageRequest);
    return this.http.get<PageResult<Street>>(`api/localities/${localityId}/streets`, { params: httpParams });
  }

}
